import {  PostTemplatePostFragmentFragment } from "@graphqlTypes"
import { Script } from "gatsby"
import React, { FC } from "react"

type PostStructuredDataProps = {
  authors?: PostTemplatePostFragmentFragment["authors"] | null,
  category?: PostTemplatePostFragmentFragment["category"],
  date?: string | null,
  dateModified?: string | null,
  description?: string | null,
  imageUrl?: string | null,
  permalink?: string | null,
  siteUrl?: string | null,
  title?: string | null,
}

const PostStructuredData: FC<PostStructuredDataProps> = ({
  authors,
  category,
  date,
  dateModified,
  description,
  imageUrl,
  permalink,
  siteUrl,
  title,
}) => (
  <>
    <Script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "name": "Blog Breadcrumbs",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Help Scout",
            "item": `${siteUrl}/`
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "Blog",
            "item": `${siteUrl}/blog/`
          },
          {
            "@type": "ListItem",
            "position": 3,
            "name": `${(category && category[0]) ? category[0].title : ""}`,
            "item": `${siteUrl}${(category && category[0]) ? category[0].permalink : ""}`
          },
          {
            "@type": "ListItem",
            "position": 4,
            "name": `${title}`,
            "item": `${siteUrl}${permalink}`
          }
        ]
      })

    }} />

    {/* Commenting out this schema for now, to test some SEO assumptions */}
    {/* Asana story: https://app.asana.com/0/1141243975964953/1208331468736664 */}
    
    {/* <Script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify({
        "@context": "http://schema.org",
        "@type": "BlogPosting",
        "mainEntityOfPage": {
          "@type": `WebPage`,
          "@id": `${siteUrl}${permalink}`
        },
        "headline": `${title}`,
        "description": `${description}`,
        "image": `${imageUrl}`,
        "datePublished": (new Date(date)).toISOString(),
        "dateModified": `${dateModified ? (new Date(dateModified)).toISOString() : (new Date(date)).toISOString()}`,
        "author": authors?.map(author => ({
          "@type": "Person",
          "name": `${author?.name || "Help Scout Contributor"}`,
          "url": author?.permalink ? `${siteUrl}${author?.permalink}`: siteUrl,
        })),
        "publisher": {
          "@type": "Organization",
          "name": "Help Scout",
          "logo": `https://www.helpscout.com/images/favicon/android-chrome-512x512.png`,
        },
      })
    }} /> */}
  </>
)

export default PostStructuredData
